// extracted by mini-css-extract-plugin
export default {"overlay":"ViewUser_overlay__Aen+q","modal":"ViewUser_modal__d0NE8","close":"ViewUser_close__aWDu9","grid":"ViewUser_grid__lW3Dc","item":"ViewUser_item__SdRwi"};